import ReceiptDetailGatewayInterface from '../../domain/Receipt/ReceiptDetailGatewayInterface';
import ReceiptDetail from '../../domain/Receipt/ReceiptDetail';
import Caller from '../../domain/Api/Caller';
import envVariable from '../../presentation/util/envVariable';
import storage from '../../presentation/util/storage';
import { getFolderIdFromUrl } from '../../infrastructure/hooks/useFolderId';

export default class FetchReceiptDetailGateway implements ReceiptDetailGatewayInterface {

  byReceiptId(receiptId: string, folderId?: string): Promise<ReceiptDetail|null> {
    const effectiveFolderId = folderId ?? getFolderIdFromUrl() ?? storage.getFolderId();
    return Caller.executeGet(`${envVariable('REACT_APP_API_URL')}/dossiers/${effectiveFolderId}/receipts/${receiptId}`, {})
      .then(response => {
        if (!response) {
          return null
        }

        return new ReceiptDetail(response.receipt.id, response.receipt.resource,response.receipt.title, response.receipt.resourceFile, response.receipt.mimetype)
      }).catch((error) => {
        return Promise.reject(error.response.data)
      })
  }

  removeById(receiptId: string, folderId?: string): Promise<boolean> {
    const effectiveFolderId = folderId ?? getFolderIdFromUrl() ?? storage.getFolderId();
    return Caller.executeDelete(`${envVariable('REACT_APP_API_URL')}/dossiers/${effectiveFolderId}/receipts/${receiptId}`, [])
      .then(response => {
        return response
      }).catch((error) => {
        return Promise.reject(error.response.data)
      })
  }
}
